module.exports = __webpack_public_path__ + "static/img/history01.897bd31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history01.jpg
// module id = NUX/
// module chunks = 1